import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetLanguagesQuery } from '../redux/apis/utilsManagement/languages/uMLanguagesApiSlice'

const LanguageDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
}) => {
  const { data, isLoading, error } = useGetLanguagesQuery({
    page: '*',
    fields: ['id','language_name'].join(','),
  })

useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Language</label>
      <br />
      <Select
        name='Language'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.language_name, value: x.id }
        })}
      />
    </div>
  )
}

export default LanguageDropdown
